import { Link } from "react-router-dom";
import { Award, Lightbulb, Wrench, Users, Layers, Cpu } from "lucide-react";
import "./AboutPage.css";
import InHoSImg from '../components/ui/Inhouse_Innovation.png'
import PropImg from '../components/ui/Proprirtary technologies.png'
import EngImg from '../components/ui/Engineering + Creativity.png'
import EndImg from '../components/ui/End to end execution.png'
import CrossImg from '../components/ui/Cross industry Expertise.png'
import IndImg from '../components/ui/Industry firsts.png'




const ADVANTAGES = [
    { icon: Lightbulb, title: "IN-HOUSE INNOVATION", img: InHoSImg, desc: "Every solution is conceptualized, engineered, and executed by our multidisciplinary team" },
    { icon: Wrench, title: "PROPRIETARY TECHNOLOGIES", img: PropImg, desc: "Patented innovations like IntelliTrack™ reflect our commitment to developing original technologies" },
    { icon: Award, title: "ENGINEERING + CREATIVITY", img: EngImg, desc: "A unique blend of technical excellence and creative thinking enables us to build experiences that leave a lasting impact" },
    { icon: Users, title: "END-TO-END EXECUTION", img: EndImg, desc: "From ideation and design to engineering, deployment, and support, we manage every stage under one roof" },
    { icon: Layers, title: "CROSS-INDUSTRY EXPERTISE", img: CrossImg, desc: "Trusted across defence, entertainment, broadcast, museums, education, government, and enterprise" },
    { icon: Cpu, title: "INDUSTRY FIRSTS", img: IndImg, desc: "From India's First AR Live Event to South India's First Live Metaverse Concert, innovation is part of our DNA" },
];




export default function AboutPage() {

    return (
        <main data-testid="about-page" className="bg-black">

            <section className="about-hero border-bottom pb-3 position-relative overflow-hidden">

                <div className="container-db d-flex flex-column gap-5 position-relative">
                    <div className="">
                        <div className="font-mono-tech section-eyebrow fade-in-up fs-5">
                            ⟶ About DB Productions
                        </div>
                        <h1
                            className="font-heading hero-title mb-3"
                            data-testid="hero-title"
                        >
                            A techno-creative
                            <br />
                            <span className="text-primary-custom">powerhouse</span>
                        </h1>
                    </div>
                    <div className="d-flex flex-column max-w-4xl">
                        <div className="about-hero-desc m-0">
                            <span style={{ color: "#fcf8f7ff", fontSize: '20px' }} className=""> Engineering the Future of Immersive Experiences </span>
                            <div>For over 30 years, DB Productions has been redefining the boundaries of creativity and technology through immersive experiences, advanced simulation systems, and engineering-driven innovations. As a multidisciplinary techno-creative company, we combine cutting-edge technologies with creative excellence to deliver solutions that transform ideas into impactful realities.

                                <div className="mt-3">Our expertise spans immersive experiences, defence-grade simulation systems, interactive museums, virtual production, broadcast technologies, projection mapping, AR, VR, MR, XR, and intelligent visualization solutions. From concept and engineering to deployment and execution, every solution is designed in-house by a team of engineers, researchers, designers, and creative technologists committed to pushing the boundaries of innovation.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <p style={{ color: "#FFF", fontSize: "32px" }}>United by engineering.  Driven by creativity.  Built for innovation.</p>
                        <br></br>
                        <p style={{ fontSize: '40px', color: "#5CDECF" }} className="text-primary-custom">
                            30+ Years of Pioneering Innovation </p>
                        <div style={{ color: '#ffffffa2', fontSize: '16px' }}>Throughout our journey, DB Productions has consistently introduced industry-first technologies and landmark projects that have shaped India's techno-creative landscape.
                        </div>
                    </div>
                </div>
            </section>

            {/* Patent banner */}
            <section className="py-5 border-bottom border-secondary bg-dark-banner">
                <div className="container-db">
                    <div className="row g-4 align-items-center">
                        <div className="col-12 col-md-3">
                            <div className="font-mono-tech patent-label mb-2 fade-in-up fs-5">
                                ⟶ Achievement
                            </div>
                            <div className="font-heading patent-title">
                                Patent
                            </div>
                        </div>
                        <div className="col-12 col-md-9">
                            <p className="text-white m-0 patent-desc">
                                India's first indigenous{" "}
                                <span className="text-primary-custom">markerless camera tracking system,</span>{" "}
                                patented in India and the USA, and deployed across film, broadcast, and live productions.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <div className="container-db mt-4 about-list-bullets" style={{ fontSize: '17px', lineHeight: '32px' }}>
                <p>30+ Years of Techno-Creative Excellence</p>
                <p>100+ Indian Films enhanced through world-class VFX expertise</p>
                <p>Introduced Hollywood VFX services to India, contributing to 36 major Hollywood films</p>
                <p>Launched IntelliStudios  India's first Virtual Production Studio service</p>
                <p>Developed IntelliTrack™ – India's first Jimmy Jib-based markerless camera tracker with patents granted in India and the USA</p>
                <p>Developed IntelliPod™ – Pedestal-based camera tracking system</p>
                <p>Photogrammetry-based VR Showroom for the Tamil Nadu Government</p>
                <p>South India's First Live Metaverse Concert, powered by motion capture technology</p>
                <p>India's First AR Live Event, redefining live audience engagement</p>
                <p>Executed AR for Election Campaigns</p>
                <p>360° Projection & Immersive Experiences delivered for leading institutions and national events</p>
                <p>Defence-grade Simulation Systems engineered for mission-critical training</p>
                <p>Interactive Museums & Experiential Installations designed for education, culture, and public engagement</p>
            </div>


            {/* Expertise grid */}
            <section className="py-5 border-bottom border-secondary">
                <div className="container-db">
                    <div className="font-mono-tech section-eyebrow mb-4 fade-in-up fs-5">
                        ⟶ Why DB
                    </div>
                    <div className="mb-4" style={{ color: '#5CDECF', fontSize: '30px', fontWeight: 'bold' }}>
                        The DB Advantage
                    </div>
                    <div className="row g-4">
                        {ADVANTAGES.map((adv) => {
                            const Icon = adv.icon;
                            return (
                                <div key={adv.title} className="col-12 col-md-6 col-lg-4">
                                    <div className="advantage-card h-100 overflow-hidden d-flex flex-column">
                                        {adv.img && (
                                            <div className="advantage-card-img-wrapper position-relative overflow-hidden">
                                                <img src={adv.img} alt={adv.title} className="advantage-card-img w-100" />
                                                <div className="advantage-card-img-overlay" />
                                            </div>
                                        )}
                                        <div className="p-4 d-flex flex-column flex-grow-1">
                                            {Icon && <Icon size={30} className="text-primary-custom mb-3" />}
                                            <h4 className="font-heading mb-3 text-white fw-bold" style={{ fontSize: '15px', letterSpacing: '0.05em' }}>
                                                {adv.title}
                                            </h4>
                                            <p className="text-muted-custom mb-0" style={{ fontSize: '14px', fontFamily: 'Inter, sans-serif', fontWeight: '400', color: '#A3A3A3', lineHeight: '1.6' }}>
                                                {adv.desc}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="py-5 py-md-10">
                <div className="container-db text-center">
                    <h3 className="font-heading section-heading mb-4">
                        Have a Vision? Let's Build It Together.
                    </h3>
                    <Link
                        to="/contact"
                        data-testid="about-cta-contact"
                        className="btn-submit font-mono-tech text-decoration-none d-inline-flex align-items-center"
                    >
                        Get in Touch
                    </Link>
                </div>
            </section>
        </main>
    );
}
